import { EMPTY_OBJ } from '@constants';

import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

import api from '..';

export const useWhereToWatchList = (queryVariables = {}, queryConfig = {}) => {
  const { data: whereToWatch = [], ...queryResult } = useResourceList(
    { name: 'whereToWatch', api: api.whereToWatch },
    queryVariables,
    queryConfig,
  );

  return {
    whereToWatch,
    latestwhereToWatch: queryResult.latestData,
    ...queryResult,
  };
};

export const useWhereToWatch = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['whereToWatch', { id }], api.whereToWatch.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    whereToWatch: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

export const useDaysForWhereToWatch = ({ eventIdWa }, queryConfig = {}) => {
  const queryResult = useQuery(['whereToWatch/days', { eventIdWa }], api.whereToWatch.getDaysForSchedule, {
    ...queryConfig,
  });

  return {
    whereToWatchDays: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'whereToWatch' });

export const useDeleteWhereToWatch = createMutation(api.whereToWatch.remove);

export const useCreateWhereToWatch = createMutation(api.whereToWatch.create);

export const useSaveWhereToWatch = createMutation(api.whereToWatch.save);

export const useUpdateWhereToWatch = createMutation(api.whereToWatch.update);
